import { PriceModelState } from "../objects/priceModelState";
import {
    PriceModelActionTypes,
    ADD_PREFERENCES,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RESET_ADD_MODEL,
    RESET_FILTERS,
    SET_ERRORS,
    SET_EXPORT_TYPE,
    SET_LIMIT,
    SET_LIST,
    SET_ORDER_BY,
    SET_PAGE,
    SET_PREFERENCES,
    SET_PRICE_MODEL,
    SET_RUNNING,
    SET_SEARCH,
    SET_STEP,
    TOGGLE_CANCEL_MODAL,
    TOGGLE_CREATE,
    TOGGLE_COLUMN,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    TOGGLE_REFRESH,
    UPDATE_FILTER_CREATED_DATE_GTE,
    UPDATE_FILTER_CREATED_DATE_LTE,
    UPDATE_FILTER_CREATOR,
    UPDATE_FILTER_LAST_AUTHOR,
    UPDATE_FILTER_MODIFIED_DATE_GTE,
    UPDATE_FILTER_MODIFIED_DATE_LTE,
    UPDATE_FILTER_PERIOD,
    UPDATE_FILTER_PERIOD_TYPE,
    UPDATE_FILTER_STATUS,
    UPDATE_LIST_ITEM_VISIBILITY,
    UPDATE_MODEL,
    UPDATE_NAME,
    UPDATE_NAME_LOCALE,
    SET_COLUMNS,
    RESIZE_COLUMN,
} from './actionTypes';
import { ModelPriceLocalized } from "../objects/modelPriceLocalized";
import { applyColumnResize } from '../../utils/list/utils/columnResize';
import { DEFAULT_PRICE_MODEL_COLUMNS, setPriceModelPreference } from '../utils/setPriceModelPreference';

const initialState: PriceModelState = {
    cancel_modal: false,
    columns: DEFAULT_PRICE_MODEL_COLUMNS,
    count: 0,
    create: false,
    errors: [],
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    filter_created_date_gte: null,
    filter_created_date_lte: null,
    filter_creator: '',
    filter_last_author: '',
    filter_modified_date_gte: null,
    filter_modified_date_lte: null,
    filter_open: false,
    filter_period_type: 0,
    filter_period: 'CREATION',
    filter_status: '',
    limit: 50,
    list: [],
    model: [],
    name: '',
    name_locales: {},
    default_name_locales: {},
    order_by: 'name',
    order: 'asc',
    page: 0,
    price_model: null,
    preferences: [],
    refresh: false,
    running: false,
    search: '',
    step: null
};

export default (state:PriceModelState = initialState, action: PriceModelActionTypes ): PriceModelState => {
    switch (action.type) {
        case ADD_PREFERENCES: {
            return { ...state, preferences: [...state.preferences, ...action.payload] };
        }
        case MOVE_DOWN_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload + 1] };
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case MOVE_UP_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload - 1] };
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case RESET_ADD_MODEL: {
            return {
                ...state,
                cancel_modal: false,
                create: false,
                model: [],
                name: '',
                name_locales: {},
                default_name_locales: {},
                price_model: null,
                step: null
            };
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_created_date_gte: null,
                filter_created_date_lte: null,
                filter_creator: '',
                filter_last_author: '',
                filter_modified_date_gte: null,
                filter_modified_date_lte: null,
                filter_open: false,
                filter_period_type: 0,
                filter_period: 'CREATION',
                filter_status: ''
            };
        }
        case SET_ERRORS: {
            return { ...state, errors: action.payload };
        }
        case SET_EXPORT_TYPE: {
            return { ...state, export_type: action.payload };
        }
        case SET_LIMIT: {
            return { ...state, list: null, limit: action.payload };
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return { ...state, count: count, list: results, running: false };
        }
        case SET_ORDER_BY: {
            return { ...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_PAGE: {
            return { ...state, list: null, page: action.payload };
        }
        case SET_PREFERENCES: {
            const { columns, preferences, order_by, order } = setPriceModelPreference(action.payload, state.columns);
            return { ...state, columns, preferences, order_by, order };
        }
        case RESIZE_COLUMN: {
            return { ...state, columns: applyColumnResize(state.columns, action.payload) };
        }
        case SET_PRICE_MODEL: {
            if (action.payload !== null) {
                const price_model = action.payload;
                const name_locales:{[index: string]: any} = {};
                let has_french = false;
                price_model.localization.map((locale: ModelPriceLocalized) => {
                    if (locale.locale === 1 && locale.name) {
                        has_french = true;
                    }
                    name_locales[locale.locale] = locale.name;
                });
                if (!has_french) {
                    name_locales['1'] = price_model.name || '';
                }
                return { ...state, price_model: action.payload, name: action.payload.name, model: action.payload.variable, name_locales, default_name_locales: name_locales };
            }
            return state;
        }
        case SET_RUNNING: {
            return { ...state, running: action.payload };
        }
        case SET_SEARCH: {
            return { ...state, search: action.payload, page: 0 };
        }
        case SET_STEP: {
            return { ...state, step: action.payload };
        }
        case TOGGLE_CANCEL_MODAL: {
            return { ...state, cancel_modal: !state.cancel_modal };
        }
        case TOGGLE_CREATE: {
            return { ...state, create: !state.create };
        }
        case TOGGLE_COLUMN: {
            const columns = [...state.columns];
            const column = { ...columns[action.payload] };
            column.checked = !column.checked;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case TOGGLE_EXPORT: {
            return { ...state, export_list: action.payload };
        }
        case TOGGLE_EXPORT_FULL: {
            return { ...state, export_full: !state.export_full };
        }
        case TOGGLE_FILTERS: {
            return { ...state, filter_open: !state.filter_open };
        }
        case TOGGLE_REFRESH: {
            return { ...state, refresh: !state.refresh };
        }
        case UPDATE_FILTER_CREATED_DATE_GTE: {
            return { ...state, filter_created_date_gte: action.payload };
        }
        case UPDATE_FILTER_CREATED_DATE_LTE: {
            return { ...state, filter_created_date_lte: action.payload };
        }
        case UPDATE_FILTER_CREATOR: {
            return { ...state, filter_creator: action.payload };
        }
        case UPDATE_FILTER_LAST_AUTHOR: {
            return { ...state, filter_last_author: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_GTE: {
            return { ...state, filter_modified_date_gte: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_LTE: {
            return { ...state, filter_modified_date_lte: action.payload };
        }
        case UPDATE_FILTER_PERIOD: {
            const period = action.payload;
            return {
                ...state,
                filter_period: period,
                filter_period_type: 0,
                filter_created_date_gte: period === 'MODIFICATION' ? null : state.filter_created_date_gte,
                filter_created_date_lte: period === 'MODIFICATION' ? null : state.filter_created_date_lte,
                filter_modified_date_gte: period === 'CREATION' ? null : state.filter_modified_date_gte,
                filter_modified_date_lte: period === 'CREATION' ? null : state.filter_modified_date_lte,
            };
        }
        case UPDATE_FILTER_PERIOD_TYPE: {
            return { ...state, filter_period_type: action.payload };
        }
        case UPDATE_FILTER_STATUS: {
            return { ...state, filter_status: action.payload };
        }
        case UPDATE_LIST_ITEM_VISIBILITY: {
            if (state.list !== null) {
                const list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === action.payload.id) {
                        list[i].deactivated = action.payload.deactivated;
                        break;
                    }
                }
                return { ...state, list: list };
            }
            return state;
        }
        case UPDATE_MODEL: {
            return { ...state, model: action.payload, errors: state.errors.filter(error => error.key !== 'model_variable_error') };
        }
        case UPDATE_NAME: {
            return { ...state, name: action.payload };
        }
        case UPDATE_NAME_LOCALE: {
            const { id, value } = action.payload;
            const name_locales = { ...state.name_locales };
            name_locales[id] = value;
            return { ...state, name_locales: name_locales };
        }
        case SET_COLUMNS: {
            return { ...state, columns: action.payload };
        }
        default:
            return state;
    }
};
